import { moment } from '../lib/moment';
import { DateRangeType } from '../model/time';

export const calculateRangeType = (from: moment.Moment, to: moment.Moment): DateRangeType | undefined => {
    if (from.clone().add(1, 'hours').valueOf() === to.valueOf()) {
        return 'hour';
    }

    if (from.clone().add(1, 'days').valueOf() === to.valueOf()) {
        return 'day';
    }

    if (from.clone().add(1, 'weeks').valueOf() === to.valueOf()) {
        return 'week';
    }

    if (from.clone().add(1, 'months').valueOf() === to.valueOf()) {
        return 'month';
    }

    if (from.clone().add(6, 'months').valueOf() === to.valueOf()) {
        return 'half_year';
    }
};
